// Profile.js
import React, { useEffect, useState } from "react";
import { getCurrentAgentInfo } from "./odooRpc";
import { FaArrowLeft, FaEnvelope, FaIdBadge, FaPercent, FaUserTie } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./App.css";

export default function Profile() {
  const [agent, setAgent] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAgentInfo = async () => {
      try {
        const info = await getCurrentAgentInfo();
        setAgent(info);
        setError("");
      } catch (err) {
        console.error("Failed to load agent info:", err.message);
        setError("Could not load agent info.");
      } finally {
        setLoading(false);
      }
    };

    fetchAgentInfo();
  }, []);

  if (loading) {
    return (
      <div className="page-state">
        <div className="spinner" />
        <p>Loading agent profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-state">
        <h2>Profile unavailable</h2>
        <p>{error}</p>
      </div>
    );
  }

  if (!agent) {
    return (
      <div className="page-state">
        <h2>No profile data</h2>
      </div>
    );
  }

  const agentTypeName = Array.isArray(agent.agent_type_id) ? agent.agent_type_id[1] : "Not assigned";

  return (
    <div className="profile-page">
      <div className="profile-card">
        <button className="profile-back" onClick={() => navigate("/")}>
          <FaArrowLeft />
          <span>Back to Dashboard</span>
        </button>

        <div className="profile-header">
          <div className="profile-avatar">
            <FaUserTie />
          </div>
          <div className="profile-header-copy">
            <div className="profile-eyebrow">Agent Profile</div>
            <h1 className="profile-title">{agent.name || "Unknown Agent"}</h1>
            <p className="profile-subtitle">
              Session-linked account details and commission settings.
            </p>
          </div>
        </div>

        <div className="profile-highlight-row">
          <div className="profile-highlight">
            <span className="profile-highlight-label">Commission</span>
            <span className="profile-highlight-value">{agent.commission || 0}%</span>
          </div>
          <div className="profile-highlight">
            <span className="profile-highlight-label">Agent Type</span>
            <span className="profile-highlight-value">{agentTypeName}</span>
          </div>
          <div className="profile-highlight">
            <span className="profile-highlight-label">Commission Basis</span>
            <span className="profile-highlight-value">
              {agent.amount_exclude_vat ? "Ex VAT" : "Including VAT"}
            </span>
          </div>
        </div>

        <div className="profile-details">
          <div className="profile-detail-row">
            <div className="profile-detail-label">
              <FaUserTie className="profile-detail-icon" />
              <span>Name</span>
            </div>
            <div className="profile-detail-value">{agent.name || "N/A"}</div>
          </div>

          <div className="profile-detail-row">
            <div className="profile-detail-label">
              <FaEnvelope className="profile-detail-icon" />
              <span>Email</span>
            </div>
            <div className="profile-detail-value">{agent.email || "N/A"}</div>
          </div>

          <div className="profile-detail-row">
            <div className="profile-detail-label">
              <FaIdBadge className="profile-detail-icon" />
              <span>Agent Code</span>
            </div>
            <div className="profile-detail-value">{agent.code || "N/A"}</div>
          </div>

          <div className="profile-detail-row">
            <div className="profile-detail-label">
              <FaIdBadge className="profile-detail-icon" />
              <span>Shop2Shop Code</span>
            </div>
            <div className="profile-detail-value">{agent.x_studio_shop2shop_code || "N/A"}</div>
          </div>

          <div className="profile-detail-row">
            <div className="profile-detail-label">
              <FaPercent className="profile-detail-icon" />
              <span>Commission Rate</span>
            </div>
            <div className="profile-detail-value">{agent.commission || 0}%</div>
          </div>

          <div className="profile-detail-row">
            <div className="profile-detail-label">
              <FaPercent className="profile-detail-icon" />
              <span>Commission Basis</span>
            </div>
            <div className="profile-detail-value">
              {agent.amount_exclude_vat ? "Amount Exclude VAT" : "Amount Include VAT"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
